export default __webpack_public_path__ + "static/media/fw-emily-er-White Gold.3969371b.mp4";